import AuthSection from './AuthSection.component';

export default AuthSection;